import RejectController from 'eflex/pods/codes/reject/controller';

export default class CodesRepairController extends RejectController {
  get codes() {
    return this.codeRepo.repairCodes;
  }
}
